import { Box} from '@mui/material';
import { Link } from 'react-router-dom';
import { styled } from '@mui/material/styles';
import logo from '../../assets/logo/amex-logo.svg';
//import logo from '../../assets/logo/logo.svg';


const LogoWrapper = styled(Link)(
  ({ theme }) => `
        color: ${theme.palette.text.primary};
        padding: ${theme.spacing(0, 1, 14, 4)};
        display: flex;
        text-decoration: none;
        font-weight: ${theme.typography.fontWeightBold};
`
);

const LogoSignWrapper = styled(Box)(
  () => `
        width: 52px;
        height: 38px;
        margin-top: 4px;
        transform: scale(.8);
`
);

function Logo() {
  return (
    <LogoWrapper to="/dashboards">
      <LogoSignWrapper>
        <img style={{width:200,height:200}} src={logo} alt={logo} />
      </LogoSignWrapper>
    </LogoWrapper>
  );
}

export default Logo;
